var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-type-picker"
  }, _vm._l(_vm.eventTypes, function (eventType, index) {
    return _c('event-icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.top",
        modifiers: {
          "hover": true,
          "top": true
        }
      }],
      key: `event-type-${index}`,
      staticClass: "event-icon",
      attrs: {
        "event-type": eventType,
        "mode": eventType === _vm.type ? 'dark' : 'light',
        "title": _vm.$t(`dashboard.events.type.${eventType}`)
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('change', eventType);
        }
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }